import { useFormik } from "formik";
import { Toast } from "primereact/toast";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import { Input } from "../../components/Input";
import { CompanyDetailID } from "../../data";
import ForgotPasswordModal from "../../modals/ForgotPassword";
import ResetPasswordModal from "../../modals/ResetPassword";
import OtpVerificationModal from "../../modals/VerifyOTP";
import {
  setEmail,
  setLoginToken,
  setToken,
  setUser,
} from "../../store/authSlice";
import useApi from "../../useApi";
import classes from "./Login.module.css";
const initialValues = {
  email: "",
  password: "",
  rememberMe: false,
};

const Login = () => {
  const { fcmToken } = useSelector((state) => state?.auth);
  const { login, forgotPassword, verifyOtp, passwordReset } = useApi();
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showOtpVerification, setShowOtpVerification] = useState(false);
  const { email } = useSelector((state) => state?.auth);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    // requestNotificationPermission().then((token) => {
    //   setFcmToken(token);
    // });
  }, []);

  const loginApi = async (data) => {
    setLoading(true);
    const result = await login(data);
    if (result?.data?.headers?.error === 200) {
      const body = result?.data?.body;
      dispatch(setLoginToken(body));
      dispatch(
        setUser({
          name: body?.userName,
          email: body?.userEmail,
          cellNumber: body?.userCellNumber,
          image: body?.userImage,
          companyName: body?.companyName,
          companyDetailId: body?.companyDetailId,
          companyTimezone: body?.companyTimezone,
          userType: body?.userType,
          menu: body?.menu,
          roleName: body?.roleName,
          roleId: body?.roleId,
          versionMatch: body?.versionMatch,
          refreshToken: body?.refreshToken,
        })
      );
      navigate("/dashboard");
    } else {
      toast.error(result?.data?.headers?.message);
    }
    setLoading(false);
  };

  const forgotPasswordApi = async (data) => {
    setLoading(true);
    const result = await forgotPassword(data);
    if (result?.data?.headers?.error === 200) {
      setShowOtpVerification(true);
      setShowForgotPasswordModal(false);
      dispatch(setEmail(data?.email));
      //set accessToken
      dispatch(setToken(result?.data?.body));
    } else {
      toast.error(result?.data?.headers?.message);
    }
    setLoading(false);
  };

  const verifyOtpApi = async (data) => {
    setLoading(true);
    const result = await verifyOtp(data);
    if (result?.data?.headers?.error === 200) {
      setShowOtpVerification(false);
      dispatch(setToken(result?.data?.body));
      setShowResetPasswordModal(true);
      //set accessToken
    } else {
      toast.error(result?.data?.headers?.message);
    }
    setLoading(false);
  };
  const passwordResetApi = async (data) => {
    setLoading(true);
    const result = await passwordReset({ ...data, email });
    if (result?.data?.headers?.error === 200) {
      dispatch(setEmail(""));
      toast.success("Password reset successfully");
      setShowResetPasswordModal(false);
      //set accessToken
    } else {
      toast.error(result?.data?.headers?.message);
    }
    setLoading(false);
  };
  const formik = useFormik({
    initialValues,
    // validationSchema: loginSchema,
    onSubmit: (values) => {
      const params = {
        email: values.email,
        password: values?.password,
        deviceToken: fcmToken,
        version: "v2.0.1",
        companyDetailID: CompanyDetailID,
      };
      loginApi(params);
      //call api
    },
  });

  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
  } = formik;
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  const isButtonDisabled = !formik.isValid || !formik.dirty;

  return (
    <>
      <Toast ref={toast} />

      <div className={classes.wrapper}>
        <div className={classes["headerWrapper"]}>
          <h2 className={classes.heading}>
            Welcome to Hall Booking Admin Portal
          </h2>
          <p className={classes.description}>
            Login with the credentials provided by your company
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={classes.separator} />
          <div onSubmit={handleSubmit} className={classes.grid}>
            <div>
              <Input
                label={"Email Address"}
                placeholder="Enter Email Address"
                type="text"
                value={values?.email}
                onChange={handleChangeWithTouch("email")}
                errorText={touched?.email && errors?.email}
              />
            </div>

            <div>
              <Input
                label={"Password"}
                type="password"
                placeholder="Enter Password"
                value={values?.password}
                onChange={handleChangeWithTouch("password")}
                errorText={touched?.password && errors?.password}
              />
            </div>
          </div>
          <div className={classes.linkAndAction}>
            {/* <span className={classes.checkWrapper}>
              <Checkbox
                type="button"
                id="rememberMe"
                value={values?.rememberMe}
                onChange={handleChangeWithTouch("rememberMe")}
              />
              <label htmlFor="rememberMe" className={classes.checkboxLabel}>
                Remember me
              </label>
            </span> */}
            <button
              type="button"
              className={classes.forgotLink}
              onClick={() => {
                setShowForgotPasswordModal(true);
              }}
            >
              Forgot Password?
            </button>
          </div>
          <div className={classes.bottomCta}>
            <Button
              label={"Continue to Login"}
              type="submit"
              disabled={loading || isButtonDisabled}
            />
          </div>
        </form>
      </div>
      {showResetPasswordModal && (
        <ResetPasswordModal
          show={showResetPasswordModal}
          setShow={setShowResetPasswordModal}
          loading={loading}
          onSubmit={passwordResetApi}
        />
      )}
      {showForgotPasswordModal && (
        <ForgotPasswordModal
          onSubmit={forgotPasswordApi}
          show={showForgotPasswordModal}
          setShow={setShowForgotPasswordModal}
          loading={loading}
        />
      )}
      {showOtpVerification && (
        <OtpVerificationModal
          show={showOtpVerification}
          setShow={setShowOtpVerification}
          onSubmit={verifyOtpApi}
          loading={loading}
        />
      )}
    </>
  );
};

export default Login;
